import { Field } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function Soil({ formField }) {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center gap-2 mt-3 flex-wrap">
      <Form.Group className="flex-fill">
        <Form.Label>{t("soil_name")}</Form.Label>
        <Field
          type="text"
          name="soil.name"
          className="form-control mb-3"
          placeholder={t("optional_soil_name")}
        />
      </Form.Group>
      <Form.Group className="flex-fill">
        <Form.Label>{t("permanent_wilting_point")}</Form.Label>
        <Field
          type="number"
          name="soil.pwp"
          className="form-control mb-3"
          placeholder="e.g. 10"
          min="0"
          max="100"
        />
      </Form.Group>
      <Form.Group className="flex-fill">
        <Form.Label>{t("effective_field_capacity")}</Form.Label>
        <Field
          type="number"
          name="soil.max_nf"
          className="form-control mb-3"
          placeholder="e.g. 25"
          min="0"
          max="100"
        />
      </Form.Group>
      <Form.Group className="flex-fill">
        <Form.Label>{t("field_capacity")}</Form.Label>
        <Field
          type="number"
          name="soil.max_f"
          className="form-control mb-3"
          placeholder="e.g. 45"
          min="0"
          max="100"
        />
      </Form.Group>
    </div>
  );
}
